// extracted by mini-css-extract-plugin
export default {"loaderWrapper":"ObsoleteConfigurationModal__loaderWrapper___WVuyj"};